import controller from './orders.controller';
import template from './orders.view.html';

let ReportOrdersComponent = {
  template,
  controller,
  bindings : {
    shCtrl : '<'
  }
};

export default ReportOrdersComponent;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/reports/orders/orders.component.js
 **/